import { Injectable } from '@angular/core';
import { Logger, LoggerLoggingLevelEnum } from './logger.service';
import { environment } from '../../../environments/environment';

export const loggerLevel = environment.loggerLevel;

const noop = (): any => undefined;

@Injectable()
export class ConsoleLoggerService implements Logger {

  get info() {
    if (loggerLevel | LoggerLoggingLevelEnum.Info) {
      return console.info.bind(console);
    } else {
      return noop;
    }
  }

  get warn() {
    if (loggerLevel | LoggerLoggingLevelEnum.Warning) {
      return console.warn.bind(console);
    } else {
      return noop;
    }
  }

  get error() {
    if (loggerLevel | LoggerLoggingLevelEnum.Error) {
      return console.error.bind(console);
    } else {
      return noop;
    }
  }
  invokeConsoleMethod(type: string, args?: any): void {
    const logFn: Function = (console)[type] || console.log || noop;
    logFn.apply(console, [args]);
  }
}
